export const API_LANGUAGES = {
    'de': "Deutsch",
    'it': "Italiano",
    'en': "English",
    'nl': "Nederlands",
    'fr': "Français",
    'da': "Dansk",
    'ru': "русский",
    'pl': "Polski",
    'hr': "Hrvatski",
    'cz': "český",
    'no': "Norsk",
    'sv': "Svenska",
    'es': "Español"
};




// WEBPACK FOOTER //
// ./src/config/languages.js